import React from 'react';
import PropTypes from 'prop-types';

export default class Wrapper extends React.Component {
  static propTypes = {
    wrapperRef: PropTypes.func.isRequired,
  };

  render() {
    return (
      <div ref={this.props.wrapperRef} className="rt-table-wrapper">
        {this.props.children}
      </div>
    );
  }
}
